import { create } from "zustand";

export const useServicesStore = create((set, get) => ({
  services: JSON.parse(sessionStorage.getItem("LS_CHECKED_ITEMS")) || [],

  updateLocalStorage: () =>
    sessionStorage.setItem("LS_CHECKED_ITEMS", JSON.stringify(get().services)),

  addToServices: (checkboxId) => {
    set((state) => ({
      services: state.services.some((service) => service === checkboxId)
        ? state.services
        : [...state.services, checkboxId],
    }));
    get().updateLocalStorage();
  },

  removeFromServices: (checkboxId) => {
    set((state) => ({
      services: state.services.filter((service) => service !== checkboxId),
    }));
    get().updateLocalStorage();
  },

  clearServices: () => {
    set({ services: [] });
    get().updateLocalStorage();
  },
}));
